export const VAPI_PUBLIC_KEY = "218baf70-2b15-4244-aafc-96c14c1e9251";
export const VAPI_ASSISTANT_ID = "eb047ce7-a497-47e5-9177-800e51a5e8c2";
